import styled, { css } from 'styled-components';

import { Horizontal, SBHorizontal } from '@sorare/core/src/atoms/layout/flex';

const lineStyles = css`
  border-radius: var(--unit);
  padding: var(--double-unit);
  background: var(--c-nd-50);
  width: 100%;
`;

export const Line = styled(Horizontal)`
  ${lineStyles}
`;

export const SBLine = styled(SBHorizontal)`
  ${lineStyles}
`;
